import classNames from "classnames";
import { SpinnerBoxProps } from "./types";
import { Spinner } from ".";
import { colorTokens } from "@/migrated-widgets/table-map/tokens";

export const SpinnerBox: React.FC<SpinnerBoxProps> = ({ boxBg = 'gray', boxClassName, className = '', color = 'black', size = 1 }) => {

    return (
        <div className={classNames('w-full', 'h-full', 'absolute', 'z-50', 'flex', 'justify-center', 'items-center', colorTokens.bgColors[boxBg], boxClassName)}>
            <Spinner color={color} size={size} className={className} />
        </div>
    )
}